import React from "react";
import Backdrop from "@mui/material/Backdrop";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  backdrop: {
    zIndex: 1300,
    color: "#fff",
  },
});

interface OcLoadingProps {
  show: boolean;
}

export const OcLoading = ({ show }: OcLoadingProps) => {
  const classes = useStyles();

  return (
    <Backdrop
      className={classes.backdrop}
      open={Boolean(show)}
      sx={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <img src="/img/owPreloading.gif" alt="Loading" />
    </Backdrop>
  );
};

export default OcLoading;
